import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import { httpClient } from './client';

/**
 * ÚNICO punto de entrada HTTP. Ningún componente/hook/thunk llama axios directo.
 * Devuelve la respuesta cruda; los servicios la convierten con `toResult` (handlers.ts).
 */
export interface ApiArgs {
  url: string;
  data?: unknown;
  config?: AxiosRequestConfig;
}

type Res = Promise<AxiosResponse<unknown>>;

export const apiAxios = {
  get: (a: ApiArgs): Res => httpClient.get(a.url, a.config),
  delete: (a: ApiArgs): Res => httpClient.delete(a.url, { ...a.config, data: a.data }),
  post: (a: ApiArgs): Res => httpClient.post(a.url, a.data, a.config),
  put: (a: ApiArgs): Res => httpClient.put(a.url, a.data, a.config),
  patch: (a: ApiArgs): Res => httpClient.patch(a.url, a.data, a.config),
};

/** Atajo: config para rutas privadas. */
export const authed = (config: AxiosRequestConfig = {}): AxiosRequestConfig => ({
  ...config,
  withAuth: true,
});
